import { withDirectives as i, openBlock as s, createElementBlock as a, renderSlot as o, vShow as r } from "vue";
import n from "./design-system.es128.js";
import c from "./design-system.es296.js";
const h = {
  name: "DsTab",
  inject: {
    emitter: {
      default() {
        return {
          on() {
          },
          off() {
          }
        };
      }
    }
  },
  props: {
    /**
     * Label to render in the tab.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Denotes whether the tab is initially active.
     */
    selected: Boolean,
    /**
     * String to insert in the data-qa attribute of the tab header.
     */
    dataQa: {
      type: String,
      default: ""
    },
    /**
     * Function to call when tab is activated.
     */
    action: Function,
    /**
     * Name of icon to render before tab label.
     */
    icon: String,
    /**
     * String list of classes to apply to the tab such as error
     */
    classList: String
  },
  setup() {
    return {
      key: `key-${c()}`
    };
  },
  data() {
    return {
      show: !1
    };
  },
  created() {
    this.$parent && typeof this.$parent.register == "function" && (this.$parent.register(this), this.selected && (this.$parent.$data.activeTab = this, this.show = !0), this.emitter.on("activateTab", this.activateTab));
  },
  beforeUnmount() {
    this.emitter.off("activateTab", this.activateTab);
  },
  methods: {
    activateTab(t) {
      this.show = t === this, this.show && t.action && t.action();
    }
  }
}, f = { class: "inner-tab" };
function p(t, l, d, u, e, m) {
  return i((s(), a("div", f, [
    o(t.$slots, "default")
  ], 512)), [
    [r, e.show]
  ]);
}
const _ = /* @__PURE__ */ n(h, [["render", p]]);
export {
  _ as default
};
//# sourceMappingURL=design-system.es97.js.map
